import React, { useRef, useState, useEffect } from "react";

function ListItem({ text, className, startingPadding, children, rotationMultiplier }) {
  const paddingIncrement = 4;
  const [paddingStyle, setPaddingStyle] = useState({});
  const [transformStyle, setTransformStyle] = useState({});

  useEffect(() => {
    if (startingPadding > 0) setStartingPadding();
    if (children) console.log(children);
  }, [startingPadding])

  const setStartingPadding = () => {
    const previousPadding = paddingStyle.padding || "0px";
    const paddingValue = parseInt(previousPadding.replace("px", ""), 10) || 0;
    const newPaddingValue = `${paddingValue + (startingPadding * paddingIncrement)}px`;
    setPaddingStyle({ padding: newPaddingValue });
  }

  const doPadding = () => {
    const previousPadding = paddingStyle.padding || "0px";
    const paddingValue = parseInt(previousPadding.replace("px", ""), 10) || 0;
    const newPaddingValue = `${paddingValue + paddingIncrement}px`;
    setPaddingStyle({ padding: newPaddingValue });
  };

  const doRotation = () => {
    const rotationAmount = 40 * (rotationMultiplier ? rotationMultiplier : 1);
    const randomAngle = Math.floor(Math.random() * rotationAmount) - (rotationAmount / 2);
    setTransformStyle({ transform: `rotate(${randomAngle}deg)` });
  };

  return (
    <span
      className={(className ? className : '') + " list_item"}
      onClick={doPadding}
      onTouchStart={doRotation}
      onMouseLeave={doRotation}
      style={{ ...transformStyle, ...paddingStyle }}
    >
      <span style={{display : 'block'}}>{text}</span>
      
      {children && (
        <>
          {children}
        </>
      )}
    </span>
  );
}

export default ListItem;
